/* eslint-disable local-rules/no-hardcoded-id-in-svg */
import React from 'react'
import { G, Path, Defs, LinearGradient, Stop, RadialGradient, Circle } from 'react-native-svg'
import styled from 'styled-components/native'

import { AccessibleSvg } from 'ui/svg/AccessibleSvg'

import { AccessibleIcon } from '../../types'

function FirstRecordedMusicBookingUnlockedSvg({
  size,
  accessibilityLabel,
  testID,
}: AccessibleIcon) {
  return (
    <AccessibleSvg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      accessibilityLabel={accessibilityLabel}
      testID={testID}>
      <G fill="none" fillRule="evenodd">
        <Path
          d="M84.5601 76.664C84.5601 76.664 53.1652 89.087 50.3505 89.087C47.5358 89.087 16.0683 76.7899 16.0683 76.7899C14.6937 76.7919 14.6202 23.9074 15.9958 23.9054C15.9958 23.9054 48.425 10 50.3515 10C52.278 10 84.4886 23.7795 84.4886 23.7795C85.12 23.7795 85.1925 76.663 84.5611 76.664H84.5601Z"
          fill="url(#paint0_linear_8631_20659)"
        />
        <Path
          d="M50.3516 89.088C53.1663 89.088 84.5612 76.665 84.5612 76.665C85.1926 76.665 85.1201 23.7795 84.4887 23.7805C84.4887 23.7805 52.2781 10.001 50.3516 10.001V89.089V89.088Z"
          fill="url(#paint1_linear_8631_20659)"
        />
        <Path
          d="M83.2512 25.7473C83.2512 25.7473 52.1956 12.3686 50.3386 12.3686C48.4816 12.3686 17.2146 25.8692 17.2146 25.8692C15.8883 25.8712 15.9588 77.2148 17.2851 77.2128C17.2851 77.2128 47.6246 89.1515 50.3386 89.1515C53.0526 89.1515 83.3216 77.09 83.3216 77.09C83.9299 77.09 83.8604 25.7453 83.2512 25.7463V25.7473ZM80.5613 74.9298C80.5613 74.9298 52.829 85.9802 50.3426 85.9802C47.8562 85.9802 20.0595 75.0416 20.0595 75.0416C18.845 75.0436 18.7805 28.0021 19.995 28.0011C19.995 28.0011 48.6417 15.6325 50.3426 15.6325C52.0435 15.6325 80.4969 27.8893 80.4969 27.8893C81.0548 27.8893 81.1192 74.9298 80.5613 74.9298Z"
          fill="#BCB6C3"
        />
        <Path
          d="M84.488 23.7795C84.488 23.7795 52.2773 10 50.3518 10C48.4263 10 15.9962 23.9054 15.9962 23.9054C14.6215 23.9074 14.694 76.7919 16.0687 76.7899C16.0687 76.7899 47.5361 89.087 50.3508 89.087C53.1655 89.087 84.5605 76.664 84.5605 76.664C85.1919 76.664 85.1194 23.7785 84.488 23.7795ZM81.6974 74.4384C81.6974 74.4384 52.9339 85.8211 50.3548 85.8211C47.7758 85.8211 18.9458 74.5542 18.9458 74.5542C17.686 74.5562 17.6195 26.1038 18.8794 26.1018C18.8794 26.1018 48.5905 13.3615 50.3548 13.3615C52.1192 13.3615 81.6309 25.986 81.6309 25.986C82.209 25.986 82.2765 74.4374 81.6974 74.4384Z"
          fill="url(#paint2_linear_8631_20659)"
        />
        <Path
          d="M24.0935 30.6779V71.2964C24.0935 71.3196 24.1076 71.3407 24.1277 71.3498L42.5901 79.4284C42.7754 79.5099 42.9385 79.2763 42.7975 79.1303L30.4269 66.2692C30.4188 66.2611 30.4138 66.2501 30.4118 66.239L24.2093 30.6678C24.1972 30.5983 24.0945 30.6064 24.0945 30.6779H24.0935Z"
          fill="#E3DEED"
        />
        <Path
          d="M75.3811 30.6779V71.2964C75.3811 71.3196 75.367 71.3407 75.3468 71.3498L56.8845 79.4284C56.6992 79.5099 56.5361 79.2763 56.677 79.1303L69.0477 66.2692C69.0558 66.2611 69.0608 66.2501 69.0628 66.239L75.2652 30.6678C75.2773 30.5983 75.3801 30.6064 75.3801 30.6779H75.3811Z"
          fill="#EFEEF0"
        />
        <Path
          d="M97.8983 49.7027C98.3957 48.8662 96.95 48.4392 96.1272 48.5394C96.011 48.5525 95.7646 48.6527 95.4346 48.8052C95.7646 48.6483 96.0063 48.5525 96.1272 48.5394L86.3885 48.2083C86.4629 49.0317 86.435 49.8944 86.3792 50.7614C86.3885 50.4259 86.4071 50.0904 86.4071 49.755C86.4071 30.5148 69.7653 14.9171 49.2372 14.9171C28.7092 14.9171 12.9599 29.6957 12.1046 48.2257L2.63083 48.5437C1.76619 48.4958 0.799295 48.7267 1.03637 49.707C1.18977 49.633 1.32458 49.6025 1.44544 49.6112C1.32923 49.6025 1.19442 49.633 1.03637 49.707L11.663 86.9674C11.821 87.2157 12.179 87.3552 12.3695 87.5469C13.6665 88.8409 15.7212 89.2286 17.5945 89.3724C34.1062 90.649 56.1031 89.6774 73.0192 89.3724C76.2174 89.3158 85.0172 89.8996 86.7418 87.6296C90.9859 75.1819 94.0586 62.3029 97.8983 49.707C97.7263 49.7767 97.5636 49.8552 97.4009 49.938C97.5636 49.8552 97.7263 49.7767 97.8937 49.707L97.8983 49.7027ZM96.1644 50.6438C96.0342 50.7178 95.9041 50.7963 95.7739 50.866C96.09 50.988 96.2109 51.1623 96.2295 51.367C96.2109 51.1623 96.09 50.9923 95.7739 50.8703C95.9087 50.8006 96.0389 50.7222 96.169 50.6481L96.1644 50.6438ZM76.1198 86.7147L82.744 64.856L76.1198 86.7191V86.7147ZM86.1886 53.5411C86.1886 53.5324 86.1886 53.5281 86.1886 53.5193C86.1886 53.5237 86.1886 53.5324 86.1886 53.5368V53.5411ZM7.26079 50.7309C7.62337 50.9357 7.97201 51.1361 8.29277 51.3191C8.77621 51.5979 9.19923 51.8463 9.51998 52.0293C9.6269 52.0903 9.71987 52.1469 9.80354 52.1905C10.4729 52.5695 11.319 53.0836 12.3091 53.698C11.319 53.0836 10.4729 52.5739 9.80354 52.1905C9.72452 52.1426 9.6269 52.0903 9.51998 52.0293C9.19923 51.8463 8.77621 51.5979 8.29277 51.3191C7.97201 51.1318 7.62337 50.9313 7.26079 50.7309C6.72155 50.4259 6.14978 50.1079 5.60125 49.816C6.15443 50.1079 6.72155 50.4259 7.26079 50.7309ZM12.4579 86.8846C13.0575 86.9064 13.6572 86.9151 14.2569 86.9195C13.6572 86.9151 13.0575 86.902 12.4579 86.8846ZM75.9385 86.8846C57.1816 86.8105 38.3782 86.767 19.6259 86.8846L15.0843 63.5315C15.0843 63.5315 15.0843 63.5315 15.0843 63.5359L19.6259 86.8803C38.3736 86.7626 57.177 86.8062 75.9385 86.8803H76.1152C79.3878 86.8933 75.9385 86.8803 75.9385 86.8803V86.8846ZM95.9506 52.9399C95.9413 52.8919 95.9366 52.844 95.932 52.7917C95.932 52.8397 95.9413 52.8876 95.9506 52.9399ZM97.3126 49.9815C97.3126 49.9815 97.3358 49.9685 97.3451 49.9641C97.3358 49.9685 97.3219 49.9772 97.3126 49.9815Z"
          fill="#7F8AA5"
        />
        <Circle cx="49.1712" cy="45.7447" r="35.7447" fill="#D9D9D9" />
        <Circle cx="49.1712" cy="45.7447" r="35.7447" fill="url(#paint3_radial_8631_20659)" />
        <Circle cx="49.1707" cy="45.7446" r="33.3333" fill="url(#paint4_radial_8631_20659)" />
        <Path
          d="M15.0828 53.013L20.7027 83.8343C18.4105 83.8499 16.1169 83.9165 13.8062 83.8343L13.7211 84.5151C13.5353 84.318 13.1906 84.1718 13.0403 83.9194L2.82324 45.691C3.62182 45.2754 3.82608 46.274 4.27005 46.5421C7.85445 48.7052 11.5112 50.752 15.0828 53.013Z"
          fill="#B7DAEC"
        />
        <Path
          d="M13.7209 84.5151L13.8061 83.8343C16.1167 83.9166 18.4103 83.8499 20.7025 83.8343C38.7323 83.7151 56.8131 83.7577 74.8514 83.8343C74.8514 83.8343 78.1691 83.8485 75.0216 83.8343V83.6641L84.8982 83.4088L94.0939 49.0116C93.9365 48.2187 94.8939 47.2839 93.9237 46.8825C94.6032 46.491 95.2415 46.0045 95.9677 45.691C92.2755 58.6159 89.3223 71.8315 85.24 84.6002C83.5805 86.9293 75.1195 86.3293 72.0429 86.3889C55.7748 86.6995 34.6245 87.6995 18.7451 86.3889C16.9465 86.24 14.9706 85.8428 13.7224 84.5151H13.7209Z"
          fill="#4665B6"
        />
        <Path
          d="M4.35511 44.4996C5.45014 44.5648 10.0033 47.4868 11.2516 48.2457C17.653 52.1421 41.0969 69.3038 46.3296 69.8712C49.3778 70.2017 53.7537 69.9988 56.5466 68.6797C65.9792 64.2215 78.0303 54.1875 87.4529 48.4159C88.4714 47.7918 93.5749 44.5889 94.2643 44.4996C95.0558 44.396 96.443 44.8343 95.9664 45.6911C95.2402 46.006 94.6033 46.4925 93.9224 46.8825C89.9196 49.1833 85.9508 51.5464 82.1735 54.2045C70.392 59.7762 58.3551 75.0527 44.2856 71.5733C34.3367 65.8428 24.8218 59.1776 15.0828 53.013C11.5111 50.752 7.85298 48.7067 4.27 46.5421C3.82603 46.274 3.62177 45.2755 2.82319 45.6911C2.59482 44.6854 3.5239 44.4499 4.35511 44.4996Z"
          fill="#E5ECFD"
        />
        <Path
          d="M13.8911 44.1592C13.7365 45.8414 13.7837 47.4568 13.8518 49.149C13.9865 49.5348 15.8614 50.3492 16.2755 50.6287C16.6174 50.8585 16.9564 51.0812 17.2968 51.3095C21.0174 53.7946 24.7592 56.2315 28.5351 58.6315C32.5862 61.206 36.4457 64.267 40.7961 66.2939C46.7535 69.0698 50.494 69.3634 56.633 66.8046C58.2486 66.1308 59.5535 65.2556 61.0599 64.4202C61.3649 64.2514 61.6216 64.0755 61.911 63.9095C65.8188 61.6712 69.5181 59.1578 73.3195 56.7578C74.5947 55.9521 75.8046 54.9975 77.0656 54.2031C77.6174 53.8556 78.2088 53.5294 78.7677 53.1819C79.6712 52.6187 80.5833 52.0258 81.4925 51.4797C81.8542 51.2627 82.1705 51.0003 82.5138 50.7989C83.3436 50.3124 84.2131 49.8783 85.0684 49.4372C85.8032 49.057 86.6103 48.5152 87.4528 48.4159C78.0301 54.1875 65.9791 64.2216 56.5464 68.6797C53.7535 69.9989 49.3777 70.2017 46.3294 69.8712C41.0968 69.3038 17.6528 52.1422 11.2514 48.2457C10.0032 47.4868 5.45002 44.5649 4.35498 44.4996L13.8911 44.1592Z"
          fill="#21232A"
        />
        <Path
          d="M94.2642 44.4996C93.5748 44.5889 88.4713 47.7932 87.4529 48.4159C86.6103 48.5152 85.4376 49.2652 84.7029 49.6454C84.7695 47.8723 85.0515 45.9223 84.8983 44.1577L94.2642 44.4981V44.4996Z"
          fill="#030406"
        />
        <Path
          d="M82.175 54.2045C82.6814 54.4343 83.0331 53.4244 83.3665 54.2896L75.0232 83.6626V83.8329C74.9665 83.8329 74.9097 83.8329 74.853 83.8329C56.8147 83.7563 38.7324 83.7137 20.7041 83.8329L15.0842 53.0116C24.8232 59.1761 34.3381 65.8414 44.2871 71.5719C58.3566 75.0513 70.3934 59.7747 82.175 54.2031V54.2045Z"
          fill="url(#paint5_linear_8631_20659)"
        />
        <Path
          d="M75.0231 83.6641L83.3664 54.2911C83.0331 53.4258 82.6813 54.4357 82.1749 54.206C85.9536 51.5478 89.921 49.1847 93.9238 46.884C94.8941 47.2854 93.9366 48.2201 94.0941 49.0131L84.8983 83.4102L75.0217 83.6655L75.0231 83.6641Z"
          fill="#4665B6"
        />
        <Path
          d="M32.1948 19.6553C34.4124 24.5491 38.6237 29.863 41.625 34.357C40.2282 35.3358 38.4776 37.531 37.5949 38.9911C37.1844 39.6706 36.4197 40.9076 36.1925 41.6191L19.0151 35.6588L19.0065 35.4888C21.2964 30.4461 24.443 25.5806 28.8105 21.8697C29.745 21.0759 31.0289 19.9409 32.1948 19.6539L32.1948 19.6553Z"
          fill="#F3ECEB"
        />
        <Path
          d="M73.3197 56.7591C69.5183 59.1605 65.819 61.6726 61.9112 63.9109L57.1438 57.6102C59.6828 56.0187 61.68 53.3804 62.7637 50.6286L73.3211 56.7591H73.3197Z"
          fill="#B7DAEC"
        />
        <Path
          d="M40.7961 56.5889C41.7862 57.3818 43.3593 58.3761 44.5422 58.803L40.7961 66.2952C36.4472 64.2683 32.5862 61.2073 28.5352 58.6328L37.816 53.525C38.8316 54.5449 39.66 55.681 40.7961 56.5903V56.5889Z"
          fill="#F3ECEB"
        />
        <Path
          d="M61.06 64.4215C59.5536 65.257 58.2487 66.1322 56.6331 66.8059L54.5891 58.8031C54.965 58.6783 55.2756 58.4428 55.6104 58.2924C56.0061 58.1151 56.4161 58.0059 56.8019 57.7818L61.0586 64.4229L61.06 64.4215Z"
          fill="#B7DAEC"
        />
        <Path
          d="M78.7692 53.1832C78.2103 53.5307 77.6188 53.857 77.0671 54.2045L63.2742 49.7775C63.3252 49.5974 63.4075 49.2768 63.4444 49.0967L78.7692 53.1832Z"
          fill="#92C3FF"
        />
        <Path
          d="M40.2855 16.9138L45.0529 32.7506C43.3975 33.2712 42.2883 34.1194 40.9663 35.135C40.7607 35.2925 40.3139 35.4513 40.2855 35.4754L31.4302 19.8102C31.4869 19.7691 32.0259 19.0074 32.3663 18.7889C34.4926 17.4272 36.8983 16.4599 39.1777 15.3833L40.0929 15.1064C40.344 15.3234 39.9511 16.8567 40.5184 16.7376L40.2855 16.9138Z"
          fill="#F3ECEB"
        />
        <Path
          d="M19.3409 35.9847L35.4331 42.796L35.5182 43.9024C35.2813 44.1208 30.487 42.684 29.7281 42.4556C29.6657 42.4372 28.31 42.0553 27.8235 41.9149C24.4107 40.9262 21.5597 40.2766 18.1072 39.4326L18.3199 38.227C18.6036 37.1631 18.4246 36.0584 19.3409 35.9847Z"
          fill="#F3ECEB"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M40.2855 35.474L31.4302 19.8088C31.3903 19.8377 31.3338 19.7874 31.2701 19.7308C31.1869 19.6568 31.0915 19.5719 31.0047 19.6386C30.8175 19.7818 29.7352 20.6599 29.7281 20.745L40.1151 35.644L40.1126 35.6414C38.497 37.1123 37.0814 39.2329 36.2814 41.2613L20.6161 32.918C19.8871 32.901 18.9835 35.3648 19.3396 35.9833L35.4317 42.7946L35.5168 43.901C35.2785 44.1194 30.4856 42.684 29.7268 42.4542L18.063 39.3889C16.9027 43.2244 16.9764 47.3435 17.297 51.3081C21.0176 53.7932 24.7594 56.2301 28.5353 58.6301L37.8161 53.5223C38.1851 53.8928 38.5296 54.2787 38.8731 54.6635C39.4747 55.3374 40.0732 56.008 40.7952 56.5866L40.7963 56.5889C41.7864 57.3818 43.3594 58.3775 44.5424 58.8031C45.5623 59.1705 46.5902 59.4167 47.6213 59.5494C46.5902 59.4167 45.5622 59.1705 44.5422 58.8031L40.7961 66.2953C46.7536 69.0712 50.4954 69.3648 56.633 66.8059L54.589 58.8031L54.5892 58.8031C54.8134 58.7286 55.014 58.6148 55.2106 58.5031C55.3436 58.4276 55.4748 58.3531 55.6105 58.2924L55.0998 56.4187C50.7154 58.6102 45.3041 58.2088 41.4771 55.057C41.3534 55.2394 41.2094 55.3806 41.078 55.5092C40.8416 55.741 40.6464 55.9322 40.6859 56.2507C40.6457 55.9315 40.8412 55.7398 41.0784 55.5071C41.2095 55.3786 41.3533 55.2375 41.4771 55.0556C35.653 50.2599 35.8842 40.7889 41.9878 36.3251L40.9665 35.1336C40.8235 35.2431 40.5638 35.3526 40.4094 35.4177C40.3417 35.4463 40.2943 35.4663 40.2856 35.4741C40.2771 35.4815 40.2622 35.4971 40.2428 35.5175C40.2103 35.5516 40.1651 35.599 40.1154 35.6443L40.1154 35.6442C40.165 35.599 40.2102 35.5516 40.2427 35.5175C40.2622 35.4971 40.277 35.4815 40.2855 35.474ZM57.0045 34.3573L57.0045 34.3573L57.0045 34.3572C56.3272 33.8993 55.2403 33.1643 54.5892 32.9195H54.5906C51.5863 31.7875 48.097 31.7918 45.0544 32.7492C43.3991 33.2698 42.2899 34.118 40.9679 35.1336L41.9892 36.3251C46.3225 33.1563 52.1353 33.2443 56.4629 36.3251L57.1438 34.4514L57.0045 34.3573Z"
          fill="url(#paint6_radial_8631_20659)"
        />
        <Path
          d="M76.7253 30.0258C71.7267 31.996 66.209 35.9364 61.5707 38.7095C60.6629 37.2655 58.5579 35.4074 57.1437 34.4527C56.4856 34.0088 55.2884 33.1832 54.5891 32.9208L61.4005 16.0627H61.5707C66.4927 18.6017 71.1948 21.9875 74.6827 26.535C75.4288 27.5081 76.4983 28.8471 76.7267 30.0258H76.7253Z"
          fill="url(#paint7_linear_8631_20659)"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M79.7902 35.3903C79.2072 33.7463 78.6796 32.6596 77.2356 30.0258L77.2342 30.0272C77.0019 29.8706 76.9807 29.8838 76.8847 29.9438L76.8847 29.9438C76.8477 29.967 76.7994 29.9971 76.7235 30.0272C73.0767 31.465 69.1518 33.9514 65.4941 36.2685C64.1406 37.126 62.8237 37.9603 61.5709 38.7097C61.5709 38.7096 61.5709 38.7095 61.5708 38.7095V38.7067C60.6644 37.2627 58.5595 35.4045 57.1439 34.4499L56.463 36.3237C63.5481 41.3691 62.9566 52.491 55.1013 56.4173L55.612 58.291C55.7592 58.2251 55.9083 58.1686 56.0575 58.112C56.309 58.0167 56.5604 57.9214 56.8024 57.781L61.0588 64.4215C61.2245 64.3293 61.3768 64.235 61.528 64.1414L61.5282 64.1412C61.6537 64.0635 61.7786 63.9862 61.9098 63.9109L57.1429 57.6108C57.1432 57.6106 57.1436 57.6104 57.1439 57.6102C59.6827 56.0188 61.6797 53.3809 62.7634 50.6293L73.3197 56.7591C73.9529 56.3591 74.57 55.9219 75.1852 55.4861L75.1852 55.4861L75.1853 55.4861L75.1853 55.486C75.8091 55.0442 76.4309 54.6037 77.0658 54.2045L63.2742 49.778C63.2743 49.7779 63.2743 49.7777 63.2744 49.7776C63.3253 49.5994 63.4072 49.279 63.4442 49.0985L78.7675 53.1846C79.1035 52.9757 79.4407 52.7625 79.7785 52.549L79.7786 52.5489L79.7788 52.5488C80.3492 52.1881 80.9213 51.8263 81.4923 51.4825C82.0016 46.0158 81.6285 40.5804 79.7902 35.3903Z"
          fill="url(#paint8_radial_8631_20659)"
        />
        <Path
          d="M61.4004 16.0626L54.5891 32.9208C51.5849 31.7889 48.0969 31.7931 45.0529 32.7506L40.2856 16.9137C39.2005 14.6541 40.3934 15.0073 42.1593 14.5293C48.5565 12.7974 55.3522 13.525 61.4019 16.0612L61.4004 16.0626Z"
          fill="url(#paint9_linear_8631_20659)"
        />
        <Path
          d="M56.4616 36.3251C63.5453 41.3691 62.9538 52.491 55.0999 56.4187C50.7155 58.6102 45.3042 58.2074 41.4772 55.057C35.6531 50.2598 35.8843 40.7903 41.9879 36.3265C46.3212 33.1577 52.134 33.2457 56.4616 36.3265V36.3251Z"
          fill="url(#paint10_linear_8631_20659)"
        />
        <Path
          d="M51.8643 40.0712C42.765 36.8456 39.626 50.0967 47.7777 51.8201C48.0501 53.4953 45.7863 52.1095 45.138 51.6499C42.4898 49.7747 41.5409 46.0527 42.6685 43.0513C43.904 39.7619 49.1068 37.0811 51.8643 40.0712Z"
          fill="#C4C3C2"
        />
        <Path
          d="M50.843 51.8216C56.4387 50.6911 57.6089 43.1081 52.5451 40.4131C52.6685 39.8173 53.5352 39.7762 53.8217 40.0726C53.9536 40.0655 55.443 41.7521 55.6103 42.0315C57.3167 44.9024 56.8614 48.8826 54.3338 51.1421C53.6288 51.7733 50.7565 53.6797 50.843 51.823V51.8216Z"
          fill="#F3ECEB"
        />
        <Path
          d="M51.8641 40.0712C52.0826 40.1492 52.3351 40.2996 52.545 40.4116C57.6088 43.1066 56.4372 50.691 50.8429 51.8201C49.6925 52.0527 48.9294 52.0641 47.7776 51.8201C39.6273 50.0967 42.7649 36.8457 51.8641 40.0712Z"
          fill="#949298"
        />
        <Path
          d="M49.0542 41.4343C55.172 40.9109 55.1549 49.2854 50.0755 49.7776C44.1422 50.3534 43.4869 41.9109 49.0542 41.4343Z"
          fill="#030406"
        />
        <Defs>
          <LinearGradient
            id="paint0_linear_8631_20659"
            x1="50"
            y1="10"
            x2="50"
            y2="89.087"
            gradientUnits="userSpaceOnUse">
            <Stop stopColor="#EEEBF3" />
            <Stop offset="1" stopColor="#B5B2BC" />
          </LinearGradient>
          <LinearGradient
            id="paint1_linear_8631_20659"
            x1="67.6758"
            y1="10.001"
            x2="67.6758"
            y2="89.089"
            gradientUnits="userSpaceOnUse">
            <Stop stopColor="#FBF6F6" />
            <Stop offset="1" stopColor="#C4C4C4" />
          </LinearGradient>
          <LinearGradient
            id="paint2_linear_8631_20659"
            x1="50"
            y1="10"
            x2="50"
            y2="89.087"
            gradientUnits="userSpaceOnUse">
            <Stop stopColor="#EEE1E0" />
            <Stop offset="1" stopColor="#C6BAB9" />
          </LinearGradient>
          <RadialGradient
            id="paint3_radial_8631_20659"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(50.4641 45.7447) rotate(-90) scale(38.3688)">
            <Stop offset="0.79" stopColor="#E3EAFF" />
            <Stop offset="1" stopColor="#9E82EA" />
          </RadialGradient>
          <RadialGradient
            id="paint4_radial_8631_20659"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(50.3764 45.7446) rotate(-89.58) scale(48.3701)">
            <Stop stopColor="#E3EAFF" />
            <Stop offset="1" stopColor="#7E9FF8" />
          </RadialGradient>
          <LinearGradient
            id="paint5_linear_8631_20659"
            x1="23.2137"
            y1="81.6312"
            x2="80.3058"
            y2="64.8227"
            gradientUnits="userSpaceOnUse">
            <Stop stopColor="#96B1F9" />
            <Stop offset="1" stopColor="#5776C9" />
          </LinearGradient>
          <RadialGradient
            id="paint6_radial_8631_20659"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(49.1711 45.6028) rotate(179.21) scale(30.854 25.246)">
            <Stop stopColor="white" />
            <Stop offset="1" stopColor="#B57FE8" />
          </RadialGradient>
          <LinearGradient
            id="paint7_linear_8631_20659"
            x1="73.8146"
            y1="26.918"
            x2="56.6288"
            y2="27.5705"
            gradientUnits="userSpaceOnUse">
            <Stop stopColor="#91CDFF" />
            <Stop offset="1" stopColor="#CEEBFF" />
          </LinearGradient>
          <RadialGradient
            id="paint8_radial_8631_20659"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(49.4549 45.6028) rotate(-3.45335) scale(24.7255 21.4827)">
            <Stop stopColor="white" />
            <Stop offset="1" stopColor="#5B7EDD" />
          </RadialGradient>
          <LinearGradient
            id="paint9_linear_8631_20659"
            x1="58.6175"
            y1="23.2215"
            x2="41.9295"
            y2="23.2981"
            gradientUnits="userSpaceOnUse">
            <Stop stopColor="#9E82EA" />
            <Stop offset="1" stopColor="#DCA1FC" />
          </LinearGradient>
          <LinearGradient
            id="paint10_linear_8631_20659"
            x1="38.6829"
            y1="45.6414"
            x2="59.4517"
            y2="46.1294"
            gradientUnits="userSpaceOnUse">
            <Stop stopColor="#FBFAFA" />
            <Stop offset="1" stopColor="#C9C7C6" />
          </LinearGradient>
        </Defs>
      </G>
    </AccessibleSvg>
  )
}

export const FirstRecordedMusicBookingUnlocked = styled(FirstRecordedMusicBookingUnlockedSvg).attrs(
  ({ size, theme }) => ({
    size: size ?? theme.illustrations.sizes.medium,
  })
)``
